var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel-tab__content" },
    [
      _c(
        "el-form",
        {
          attrs: {
            model: _vm.flowConditionForm,
            "label-width": "90px",
            size: "mini",
            "label-position": "top"
          },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "流转类型" } },
            [
              _c(
                "el-select",
                {
                  on: { change: _vm.updateFlowType },
                  model: {
                    value: _vm.flowConditionForm.type,
                    callback: function($$v) {
                      _vm.$set(_vm.flowConditionForm, "type", $$v)
                    },
                    expression: "flowConditionForm.type"
                  }
                },
                [
                  _c("el-option", {
                    attrs: { label: "普通流转路径", value: "normal" }
                  }),
                  _c("el-option", {
                    attrs: { label: "默认流转路径", value: "default" }
                  }),
                  _c("el-option", {
                    attrs: { label: "条件流转路径", value: "condition" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm.flowConditionForm.type === "condition"
            ? _c(
                "el-form-item",
                {
                  key: "condition",
                  staticStyle: { "margin-bottom": "8px" },
                  attrs: { label: "添加条件" }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { round: "", type: "" },
                      on: { click: _vm.addConditionGroup }
                    },
                    [_vm._v("添加条件组")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.flowConditionForm.conditionType &&
          _vm.flowConditionForm.conditionType === "script"
            ? [
                _c(
                  "el-form-item",
                  { key: "language", attrs: { label: "脚本语言" } },
                  [
                    _c("el-input", {
                      attrs: { clearable: "" },
                      on: { change: _vm.updateFlowCondition },
                      model: {
                        value: _vm.flowConditionForm.language,
                        callback: function($$v) {
                          _vm.$set(_vm.flowConditionForm, "language", $$v)
                        },
                        expression: "flowConditionForm.language"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { key: "scriptType", attrs: { label: "脚本类型" } },
                  [
                    _c(
                      "el-select",
                      {
                        model: {
                          value: _vm.flowConditionForm.scriptType,
                          callback: function($$v) {
                            _vm.$set(_vm.flowConditionForm, "scriptType", $$v)
                          },
                          expression: "flowConditionForm.scriptType"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "内联脚本", value: "inlineScript" }
                        }),
                        _c("el-option", {
                          attrs: { label: "外部脚本", value: "externalScript" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.flowConditionForm.scriptType === "inlineScript"
                  ? _c(
                      "el-form-item",
                      { key: "body", attrs: { label: "脚本" } },
                      [
                        _c("el-input", {
                          attrs: { type: "textarea", clearable: "" },
                          on: { change: _vm.updateFlowCondition },
                          model: {
                            value: _vm.flowConditionForm.body,
                            callback: function($$v) {
                              _vm.$set(_vm.flowConditionForm, "body", $$v)
                            },
                            expression: "flowConditionForm.body"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.flowConditionForm.scriptType === "externalScript"
                  ? _c(
                      "el-form-item",
                      { key: "resource", attrs: { label: "资源地址" } },
                      [
                        _c("el-input", {
                          attrs: { clearable: "" },
                          on: { change: _vm.updateFlowCondition },
                          model: {
                            value: _vm.flowConditionForm.resource,
                            callback: function($$v) {
                              _vm.$set(_vm.flowConditionForm, "resource", $$v)
                            },
                            expression: "flowConditionForm.resource"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      ),
      [
        _c(
          "el-form",
          {
            ref: "validateForm",
            attrs: { size: "mini", model: _vm.conditionForm }
          },
          _vm._l(_vm.conditionForm.conditionList, function(item, index) {
            return _c(
              "div",
              { key: item.id, staticClass: "card" },
              [
                _c(
                  "el-card",
                  [
                    _c(
                      "div",
                      {
                        staticClass: "clearfix",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [
                        _c("span", [_vm._v("条件组")]),
                        _c("el-button", {
                          staticStyle: { float: "right" },
                          attrs: {
                            icon: "el-icon-delete",
                            size: "mini",
                            circle: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.delCondition(index)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._l(item.checkConditionList, function(sub, i) {
                      return _c(
                        "main",
                        { key: i },
                        [
                          sub.formType == "number" ||
                          sub.formType == "inumber" ||
                          sub.formType == "date-range"
                            ? [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 8 } },
                                  [
                                    _c("el-col", { attrs: { span: 4 } }, [
                                      _vm._v(" " + _vm._s(sub.fieldName))
                                    ]),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 10 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "conditionList." +
                                                index +
                                                ".checkConditionList." +
                                                i +
                                                ".operator",
                                              rules: _vm.rules
                                            }
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: { size: "mini" },
                                                model: {
                                                  value: sub.operator,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      sub,
                                                      "operator",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "sub.operator"
                                                }
                                              },
                                              _vm._l(
                                                _vm.$store.state.bpm
                                                  .operatorNumOption,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.id,
                                                    attrs: {
                                                      label: item.label,
                                                      value: item.value
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    sub.operator == "<" ||
                                    sub.operator == "==" ||
                                    sub.operator == ">" ||
                                    sub.operator == "<=" ||
                                    sub.operator == ">="
                                      ? _c(
                                          "el-col",
                                          { attrs: { span: 10 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  prop:
                                                    "conditionList." +
                                                    index +
                                                    ".checkConditionList." +
                                                    i +
                                                    ".val1",
                                                  rules: _vm.rules
                                                }
                                              },
                                              [
                                                _c("el-input-number", {
                                                  staticStyle: {
                                                    width: "100%"
                                                  },
                                                  attrs: { size: "mini" },
                                                  model: {
                                                    value: sub.val1,
                                                    callback: function($$v) {
                                                      _vm.$set(sub, "val1", $$v)
                                                    },
                                                    expression: "sub.val1"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                sub.operator == "in"
                                  ? _c(
                                      "el-row",
                                      { attrs: { gutter: 4 } },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 5 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  prop:
                                                    "conditionList." +
                                                    index +
                                                    ".checkConditionList." +
                                                    i +
                                                    ".val1",
                                                  rules: _vm.rules
                                                }
                                              },
                                              [
                                                _c("el-input-number", {
                                                  staticStyle: {
                                                    width: "100%"
                                                  },
                                                  attrs: {
                                                    size: "mini",
                                                    "controls-position": "right"
                                                  },
                                                  model: {
                                                    value: sub.val1,
                                                    callback: function($$v) {
                                                      _vm.$set(sub, "val1", $$v)
                                                    },
                                                    expression: "sub.val1"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 5 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  prop:
                                                    "conditionList." +
                                                    index +
                                                    ".checkConditionList." +
                                                    i +
                                                    ".extra1",
                                                  rules: _vm.rules
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticStyle: {
                                                      width: "100%"
                                                    },
                                                    attrs: { size: "mini" },
                                                    model: {
                                                      value: sub.extra1,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          sub,
                                                          "extra1",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "sub.extra1"
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.$store.state.bpm
                                                      .extraOption,
                                                    function(item) {
                                                      return _c("el-option", {
                                                        key: item.id,
                                                        attrs: {
                                                          label: item.label,
                                                          value: item.value
                                                        }
                                                      })
                                                    }
                                                  ),
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          {
                                            staticStyle: {
                                              "text-align": "center",
                                              "font-size": "12px"
                                            },
                                            attrs: { span: 4 }
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(sub.fieldName) + " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 5 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  prop:
                                                    "conditionList." +
                                                    index +
                                                    ".checkConditionList." +
                                                    i +
                                                    ".extra2",
                                                  rules: _vm.rules
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticStyle: {
                                                      width: "100%"
                                                    },
                                                    attrs: { size: "mini" },
                                                    model: {
                                                      value: sub.extra2,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          sub,
                                                          "extra2",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "sub.extra2"
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.$store.state.bpm
                                                      .extraOption,
                                                    function(item) {
                                                      return _c("el-option", {
                                                        key: item.id,
                                                        attrs: {
                                                          label: item.label,
                                                          value: item.value
                                                        }
                                                      })
                                                    }
                                                  ),
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 5 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  prop:
                                                    "conditionList." +
                                                    index +
                                                    ".checkConditionList." +
                                                    i +
                                                    ".val2",
                                                  rules: _vm.rules
                                                }
                                              },
                                              [
                                                _c("el-input-number", {
                                                  staticStyle: {
                                                    width: "100%"
                                                  },
                                                  attrs: {
                                                    size: "mini",
                                                    "controls-position": "right"
                                                  },
                                                  model: {
                                                    value: sub.val2,
                                                    callback: function($$v) {
                                                      _vm.$set(sub, "val2", $$v)
                                                    },
                                                    expression: "sub.val2"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            : _vm._e(),
                          sub.formType == "amountMoney"
                            ? [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 8 } },
                                  [
                                    _c("el-col", { attrs: { span: 4 } }, [
                                      _vm._v(" " + _vm._s(sub.fieldName))
                                    ]),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 10 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "conditionList." +
                                                index +
                                                ".checkConditionList." +
                                                i +
                                                ".operator",
                                              rules: _vm.rules
                                            }
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: { size: "mini" },
                                                model: {
                                                  value: sub.operator,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      sub,
                                                      "operator",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "sub.operator"
                                                }
                                              },
                                              _vm._l(
                                                _vm.$store.state.bpm
                                                  .operatorNumOption,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.id,
                                                    attrs: {
                                                      label: item.label,
                                                      value: item.value
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    sub.operator == "<" ||
                                    sub.operator == "==" ||
                                    sub.operator == ">" ||
                                    sub.operator == "<=" ||
                                    sub.operator == ">="
                                      ? _c(
                                          "el-col",
                                          { attrs: { span: 10 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  prop:
                                                    "conditionList." +
                                                    index +
                                                    ".checkConditionList." +
                                                    i +
                                                    ".val1",
                                                  rules: _vm.rules
                                                }
                                              },
                                              [
                                                _c("el-input-number", {
                                                  staticStyle: {
                                                    width: "100%"
                                                  },
                                                  attrs: {
                                                    size: "mini",
                                                    precision: 2,
                                                    step: 1
                                                  },
                                                  model: {
                                                    value: sub.val1,
                                                    callback: function($$v) {
                                                      _vm.$set(sub, "val1", $$v)
                                                    },
                                                    expression: "sub.val1"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                sub.operator == "in"
                                  ? _c(
                                      "el-row",
                                      { attrs: { gutter: 4 } },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 5 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  prop:
                                                    "conditionList." +
                                                    index +
                                                    ".checkConditionList." +
                                                    i +
                                                    ".val1",
                                                  rules: _vm.rules
                                                }
                                              },
                                              [
                                                _c("el-input-number", {
                                                  staticStyle: {
                                                    width: "100%"
                                                  },
                                                  attrs: {
                                                    size: "mini",
                                                    precision: 2,
                                                    step: 1,
                                                    "controls-position": "right"
                                                  },
                                                  model: {
                                                    value: sub.val1,
                                                    callback: function($$v) {
                                                      _vm.$set(sub, "val1", $$v)
                                                    },
                                                    expression: "sub.val1"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 5 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  prop:
                                                    "conditionList." +
                                                    index +
                                                    ".checkConditionList." +
                                                    i +
                                                    ".extra1",
                                                  rules: _vm.rules
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticStyle: {
                                                      width: "100%"
                                                    },
                                                    attrs: { size: "mini" },
                                                    model: {
                                                      value: sub.extra1,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          sub,
                                                          "extra1",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "sub.extra1"
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.$store.state.bpm
                                                      .extraOption,
                                                    function(item) {
                                                      return _c("el-option", {
                                                        key: item.id,
                                                        attrs: {
                                                          label: item.label,
                                                          value: item.value
                                                        }
                                                      })
                                                    }
                                                  ),
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          {
                                            staticStyle: {
                                              "text-align": "center",
                                              "font-size": "12px"
                                            },
                                            attrs: { span: 4 }
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(sub.fieldName) + " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 5 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  prop:
                                                    "conditionList." +
                                                    index +
                                                    ".checkConditionList." +
                                                    i +
                                                    ".extra2",
                                                  rules: _vm.rules
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticStyle: {
                                                      width: "100%"
                                                    },
                                                    attrs: { size: "mini" },
                                                    model: {
                                                      value: sub.extra2,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          sub,
                                                          "extra2",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "sub.extra2"
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.$store.state.bpm
                                                      .extraOption,
                                                    function(item) {
                                                      return _c("el-option", {
                                                        key: item.id,
                                                        attrs: {
                                                          label: item.label,
                                                          value: item.value
                                                        }
                                                      })
                                                    }
                                                  ),
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 5 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  prop:
                                                    "conditionList." +
                                                    index +
                                                    ".checkConditionList." +
                                                    i +
                                                    ".val2",
                                                  rules: _vm.rules
                                                }
                                              },
                                              [
                                                _c("el-input-number", {
                                                  staticStyle: {
                                                    width: "100%"
                                                  },
                                                  attrs: {
                                                    size: "mini",
                                                    "controls-position": "right"
                                                  },
                                                  model: {
                                                    value: sub.val2,
                                                    callback: function($$v) {
                                                      _vm.$set(sub, "val2", $$v)
                                                    },
                                                    expression: "sub.val2"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            : _vm._e(),
                          sub.formType == "radio"
                            ? [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 8 } },
                                  [
                                    _c("el-col", { attrs: { span: 4 } }, [
                                      _vm._v(" " + _vm._s(sub.fieldName))
                                    ]),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 20 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "conditionList." +
                                                index +
                                                ".checkConditionList." +
                                                i +
                                                ".valList",
                                              rules: _vm.rules
                                            }
                                          },
                                          [
                                            _c(
                                              "el-checkbox-group",
                                              {
                                                staticStyle: { width: "100%" },
                                                model: {
                                                  value: sub.valList,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      sub,
                                                      "valList",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "sub.valList"
                                                }
                                              },
                                              _vm._l(sub.optList, function(e) {
                                                return _c(
                                                  "el-checkbox",
                                                  {
                                                    key: e.label,
                                                    attrs: { label: e.value }
                                                  },
                                                  [_vm._v(_vm._s(e.label))]
                                                )
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            : _vm._e(),
                          sub.formType == "checkbox"
                            ? [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 8 } },
                                  [
                                    _c("el-col", { attrs: { span: 4 } }, [
                                      _vm._v(" " + _vm._s(sub.fieldName))
                                    ]),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 20 } },
                                      [
                                        _c(
                                          "el-row",
                                          {
                                            staticStyle: {
                                              "margin-bottom": "0px"
                                            },
                                            attrs: { gutter: 8 }
                                          },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 8 } },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      prop:
                                                        "conditionList." +
                                                        index +
                                                        ".checkConditionList." +
                                                        i +
                                                        ".operator",
                                                      rules: _vm.rules
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "100%"
                                                        },
                                                        attrs: { size: "mini" },
                                                        model: {
                                                          value: sub.operator,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              sub,
                                                              "operator",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "sub.operator"
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm.$store.state.bpm
                                                          .operatorOption,
                                                        function(item) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: item.id,
                                                              attrs: {
                                                                label:
                                                                  item.label,
                                                                value:
                                                                  item.value
                                                              }
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 16 } },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      prop:
                                                        "conditionList." +
                                                        index +
                                                        ".checkConditionList." +
                                                        i +
                                                        ".valList",
                                                      rules: _vm.rules
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "100%"
                                                        },
                                                        attrs: {
                                                          size: "mini",
                                                          multiple: ""
                                                        },
                                                        model: {
                                                          value: sub.valList,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              sub,
                                                              "valList",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "sub.valList"
                                                        }
                                                      },
                                                      _vm._l(
                                                        sub.optList,
                                                        function(item) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: item.id,
                                                              attrs: {
                                                                label:
                                                                  item.label,
                                                                value:
                                                                  item.value
                                                              }
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            : _vm._e(),
                          sub.formType == "selectOptions" ||
                          sub.formType == "select"
                            ? [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 8 } },
                                  [
                                    _c("el-col", { attrs: { span: 4 } }, [
                                      _vm._v(" " + _vm._s(sub.fieldName))
                                    ]),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 20 } },
                                      [
                                        _c(
                                          "el-row",
                                          {
                                            staticStyle: {
                                              "margin-bottom": "0px"
                                            },
                                            attrs: { gutter: 8 }
                                          },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 8 } },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      prop:
                                                        "conditionList." +
                                                        index +
                                                        ".checkConditionList." +
                                                        i +
                                                        ".operator",
                                                      rules: _vm.rules
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "100%"
                                                        },
                                                        attrs: { size: "mini" },
                                                        model: {
                                                          value: sub.operator,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              sub,
                                                              "operator",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "sub.operator"
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm.$store.state.bpm
                                                          .operatorOption,
                                                        function(item) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: item.id,
                                                              attrs: {
                                                                label:
                                                                  item.label,
                                                                value:
                                                                  item.value
                                                              }
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 16 } },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      prop:
                                                        "conditionList." +
                                                        index +
                                                        ".checkConditionList." +
                                                        i +
                                                        ".valList",
                                                      rules: _vm.rules
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "100%"
                                                        },
                                                        attrs: {
                                                          size: "mini",
                                                          multiple: ""
                                                        },
                                                        model: {
                                                          value: sub.valList,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              sub,
                                                              "valList",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "sub.valList"
                                                        }
                                                      },
                                                      _vm._l(
                                                        sub.optList,
                                                        function(item) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: item.id,
                                                              attrs: {
                                                                label:
                                                                  item.label,
                                                                value:
                                                                  item.value
                                                              }
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            : _vm._e(),
                          sub.formType == "department"
                            ? [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 8 } },
                                  [
                                    _c("el-col", { attrs: { span: 4 } }, [
                                      _vm._v(" " + _vm._s(sub.fieldName))
                                    ]),
                                    _c("el-col", { attrs: { span: 20 } }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "select_box",
                                          staticStyle: {
                                            "margin-bottom": "8px"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-tag",
                                            {
                                              staticStyle: {
                                                cursor: "pointer"
                                              },
                                              attrs: {
                                                type: "info",
                                                size: "mini"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.addUser(
                                                    sub.valList,
                                                    1
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(" 添加 ")]
                                          ),
                                          _vm._l(sub.valList, function(
                                            item,
                                            index
                                          ) {
                                            return _c(
                                              "el-tag",
                                              {
                                                key: item.value,
                                                attrs: {
                                                  type: "info",
                                                  size: "mini",
                                                  closable: ""
                                                },
                                                on: {
                                                  close: function($event) {
                                                    return _vm.closeUser(
                                                      index,
                                                      sub.valList
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(item.name) + " "
                                                )
                                              ]
                                            )
                                          })
                                        ],
                                        2
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ]
                            : _vm._e(),
                          sub.formType == "bpm_initiator"
                            ? [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 8 } },
                                  [
                                    _c("el-col", { attrs: { span: 4 } }, [
                                      _vm._v(" " + _vm._s(sub.fieldName))
                                    ]),
                                    _c("el-col", { attrs: { span: 20 } }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "select_box",
                                          staticStyle: {
                                            "margin-bottom": "8px"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-tag",
                                            {
                                              staticStyle: {
                                                cursor: "pointer"
                                              },
                                              attrs: {
                                                type: "info",
                                                size: "mini"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.addUser(
                                                    sub.valList,
                                                    0
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(" 添加 ")]
                                          ),
                                          _vm._l(sub.valList, function(
                                            item,
                                            index
                                          ) {
                                            return _c(
                                              "el-tag",
                                              {
                                                key: item.value,
                                                attrs: {
                                                  type: "info",
                                                  size: "mini",
                                                  closable: ""
                                                },
                                                on: {
                                                  close: function($event) {
                                                    return _vm.closeUser(
                                                      index,
                                                      sub.valList
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(item.name) + " "
                                                )
                                              ]
                                            )
                                          })
                                        ],
                                        2
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ]
                            : _vm._e(),
                          i != item.checkConditionList.length - 1
                            ? _c("p", [_vm._v("且")])
                            : _vm._e()
                        ],
                        2
                      )
                    }),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", icon: "el-icon-plus" },
                        on: {
                          click: function($event) {
                            return _vm.selectionCriteria(index)
                          }
                        }
                      },
                      [_vm._v("添加条件")]
                    )
                  ],
                  2
                ),
                index != _vm.conditionForm.conditionList.length - 1
                  ? _c("div", [_vm._v("或")])
                  : _vm._e()
              ],
              1
            )
          }),
          0
        )
      ],
      _vm.conditionForm.conditionList.length &&
      _vm.flowConditionForm.type === "condition"
        ? _c(
            "el-button",
            {
              staticStyle: { "margin-top": "10px" },
              attrs: { type: "primary", size: "mini", loading: _vm.loading },
              on: {
                click: function($event) {
                  return _vm.saveExpression("validateForm")
                }
              }
            },
            [_vm._v("保存")]
          )
        : _vm._e(),
      _vm.selectionCriteriaVisible
        ? _c(
            "Customdialog",
            {
              attrs: {
                dialogWidth: "560px",
                title: "选择条件",
                dialogHeight: "200px",
                isFooter: true
              },
              on: {
                closeDialog: function($event) {
                  _vm.selectionCriteriaVisible = false
                },
                submitDialog: _vm.affirmCheckList
              }
            },
            [
              _c("template", { slot: "dialogMain" }, [
                _c(
                  "div",
                  { staticStyle: { padding: "0 24px" } },
                  [
                    _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                      _vm._v(
                        " 请选择用来区分审批流程的条件字段 ，已选" +
                          _vm._s(_vm.checkList.length) +
                          "个 "
                      )
                    ]),
                    _c(
                      "el-checkbox-group",
                      {
                        on: { change: _vm.changeCheckList },
                        model: {
                          value: _vm.checkList,
                          callback: function($$v) {
                            _vm.checkList = $$v
                          },
                          expression: "checkList"
                        }
                      },
                      _vm._l(_vm.formInfo, function(item, index) {
                        return _c(
                          "el-checkbox",
                          { key: index, attrs: { label: item.fieldVal } },
                          [_vm._v(_vm._s(item.fieldName))]
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            2
          )
        : _vm._e(),
      _c("initiatingRange", {
        ref: "initiatingRange",
        attrs: {
          selectedList: _vm.chooseList,
          title: _vm.title,
          isUser: _vm.isUser,
          addType: _vm.addType,
          radio: _vm.radio,
          isGroup: _vm.isGroup
        },
        on: { confirm: _vm.getChooseList }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }